import { GridWrapper } from "../../../components";
import { FormTextArea } from "../../../components/forms";
import InstructionRow from "./InstructionRow";

const EarmarkCashInstructionRow = ({ data, updateFn }) => {

    const { earmarkCashApplies, earmarkCashComment } = data || {};

    return <>
        <InstructionRow
            data={data}
            updateFn={updateFn}
            label={"Earmark Cash"}
            appliesProperty={"earmarkCashApplies"}
            cashAmountProperty={"earmarkCashAmount"}
            dateInstructedProperty={"earmarkCashInstructedDate"}
            instructedDateSetProperty={"earmarkCashInstructedSetDate"}
            instructedByProperty={"earmarkCashInstructedByName"}
            dateConfirmedProperty={"earmarkCashConfirmedDate"}
            confirmedDateSetProperty={"earmarkCashConfirmedSetDate"}
            confirmedByProperty={"earmarkCashConfirmedByName"}
        />

        {earmarkCashApplies && <GridWrapper className="mb-3" gridTemplateColumns="repeat(7, 1fr)" gridColumnGap="24px">
            <div className="col-start-1 col-end-4">
                <FormTextArea
                    value={earmarkCashComment}
                    minRows={1}
                    maxRows={3}
                    onBlur={value => updateFn("earmarkCashComment", value)}
                />
            </div>
        </GridWrapper>}
    </>
}

export default EarmarkCashInstructionRow;